// extracted by mini-css-extract-plugin
export default {"blogList":"BlogList_blogList__epU4k","blogList_head":"BlogList_blogList_head__DQVJO","blogList_head_list":"BlogList_blogList_head_list__UQnCC"};